// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ea695a30","732":"c548a8f6","977":"baf4a1a9"}[chunkId] + ".chunk.js";
};